import React, { useState } from "react";
import { DatabaseBackup, Download, FileSpreadsheet } from "lucide-react";
import { toast } from "sonner";
import { errMsg } from "../lib/api";
import { downloadFile } from "../lib/download";
import { Breadcrumb } from "../components/Breadcrumb";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";

const ISI = ["Data Kartu Keluarga (Excel: daftar KK + anggota keluarga)", "Data Presensi (Excel: sesi + detail kehadiran)", "Data Kunjungan Jemaat (Excel)", "Data Rekap Aktivitas Care Leader (Excel + ringkasan per CL)"];

export default function ExportBackupPage() {
  const [busy, setBusy] = useState(false);
  const tgl = new Date().toISOString().slice(0, 10);
  const unduh = async () => {
    setBusy(true);
    try { await downloadFile("/backup/export-semua", {}, `Backup_SIAP_${tgl}.zip`); toast.success("Backup berhasil diunduh"); }
    catch (e) { toast.error(errMsg(e, "Gagal mengekspor backup")); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-5 max-w-3xl" data-testid="export-backup-page">
      <div>
        <Breadcrumb items={[{ label: "Pengaturan" }, { label: "Export Backup" }]} />
        <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 flex items-center gap-2"><DatabaseBackup className="h-7 w-7 text-[hsl(24,94%,45%)]" /> Export Backup</h1>
        <p className="text-sm text-slate-500">Unduh seluruh data penting dalam satu file ZIP untuk arsip atau cadangan.</p>
      </div>
      <Card className="p-5 rounded-2xl space-y-4">
        <ul className="space-y-2">
          {ISI.map((t) => <li key={t} className="flex items-center gap-2 text-sm text-slate-700"><FileSpreadsheet className="h-4 w-4 text-emerald-600 shrink-0" />{t}</li>)}
        </ul>
        <div className="text-xs text-slate-500">Nama file: <span className="font-mono" data-testid="backup-nama-file">Backup_SIAP_{tgl}.zip</span></div>
        <Button onClick={unduh} disabled={busy} className="rounded-xl min-h-[48px] px-6" data-testid="backup-export-btn"><Download className="h-4 w-4 mr-2" />{busy ? "Menyiapkan backup..." : "Export Semua Data"}</Button>
        <p className="text-[11px] text-slate-400">Hanya Admin dan Sekretariat. Setiap export tercatat di audit log.</p>
      </Card>
    </div>
  );
}
